import { IconType, SvgIcon } from './SvgIcon';

export const PlayIcon: IconType = (props) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 20 20">
    <path
      d="M4.16675 4.16667C4.16666 3.87342 4.24395 3.58533 4.39082 3.3315C4.53768 3.07767 4.74892 2.86708 5.00321 2.721C5.25749 2.57492 5.54582 2.49853 5.83907 2.49952C6.13233 2.50052 6.42013 2.57887 6.67342 2.72667L16.6709 8.55834C16.9232 8.70474 17.1327 8.91479 17.2784 9.16751C17.4241 9.42023 17.5009 9.70675 17.5011 9.99845C17.5014 10.2902 17.4251 10.5768 17.2798 10.8298C17.1346 11.0828 16.9255 11.2932 16.6734 11.44L6.67342 17.2733C6.42013 17.4211 6.13233 17.4995 5.83907 17.5005C5.54582 17.5015 5.25749 17.4251 5.00321 17.279C4.74892 17.1329 4.53768 16.9223 4.39082 16.6685C4.24395 16.4147 4.16666 16.1266 4.16675 15.8333V4.16667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

PlayIcon.displayName = 'PlayIcon';
